import {useEffect} from "react";
import useCurrentRoute from "./useCurrentRoute";
import { triggerScroll } from "./../../../shared/helpers";

const useScrollToTop = (): null => {
  const pathname = useCurrentRoute();

  useEffect((): void  => {
    triggerScroll();
  }, [pathname]);

  return null;
}

export default useScrollToTop;
